module.exports = __webpack_public_path__ + "media/images/home/desktop_banner_background-b94b4e94a9a0bdc5cc50b9eac674cd4b.png";